import { Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useSite, LANG_LABELS } from "@/context/SiteContext";

export const LanguageSwitcher = () => {
  const { config, lang, setLang } = useSite();
  const langs = config?.languages;
  if (!langs?.show_switcher || (langs.enabled || []).length < 2) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="language-switcher" aria-label="Language"
        className="h-10 px-2 flex items-center gap-1 text-neutral-900 hover:text-[#d00000] transition-colors text-xs font-semibold uppercase">
        <Globe className="w-4 h-4" /> {lang}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-none bg-white">
        {langs.enabled.map((l) => (
          <DropdownMenuItem key={l} onClick={() => setLang(l)} data-testid={`language-option-${l}`}
            className={`rounded-none cursor-pointer ${l === lang ? "text-[#d00000] font-semibold" : ""}`}>
            {LANG_LABELS[l] || l}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
